import { BasicPermissionItem } from '../../PermissionItem'
import { Simple } from '../../common'
import { Users } from '../../../cimsPage/instances/admin'

const page = Users
const object = 'User'

export const ViewUser = Simple({
  id: '783b37e9-f911-4d60-aa39-a3d50702bf17',
  page,
  object,
  action: 'View',
})
export const EditUserRole = new BasicPermissionItem({
  id: '2f016ff4-cb8f-45e7-ad6b-9bf8354e52f7',
  page,
  action: 'edit user roles',
  name: 'Edit User Role',
})
export const EditUserPermission = new BasicPermissionItem({
  id: 'c8a14fe0-fe0e-4929-8125-7bb216cada26',
  page,
  action: 'edit user permissions',
  name: 'Edit User Permission',
})
export type UserPermission =
  | typeof ViewUser
  | typeof EditUserRole
  | typeof EditUserPermission
